import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Login({ onSwitch }) {
  const { login } = useAuth();
  const [phone, setPhone]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(phone, password);
    } catch (err) {
      setError(err.response?.data?.error || 'خطأ في تسجيل الدخول');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>🚀</div>
        <h1 style={styles.title}>بسرعة</h1>
        <p style={styles.subtitle}>منصة التوصيل السريع</p>
        <form onSubmit={handleSubmit}>
          <input
            style={styles.input}
            type="tel"
            placeholder="رقم الهاتف"
            value={phone}
            onChange={e => setPhone(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="password"
            placeholder="كلمة المرور"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          {error && <p style={styles.error}>{error}</p>}
          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? 'جاري الدخول...' : 'تسجيل الدخول'}
          </button>
        </form>
        <p style={styles.switchText}>
          مش عندك حساب؟{' '}
          <span style={styles.link} onClick={onSwitch}>سجّل دلوقتي</span>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'linear-gradient(135deg,#10b981,#059669)', padding:'20px' },
  card:      { background:'#fff', borderRadius:'20px', padding:'40px 30px', width:'100%', maxWidth:'400px', boxShadow:'0 20px 60px rgba(0,0,0,0.3)', textAlign:'center' },
  logo:      { fontSize:'50px', marginBottom:'10px' },
  title:     { fontSize:'32px', fontWeight:'bold', color:'#333', margin:'0 0 5px' },
  subtitle:  { color:'#888', marginBottom:'30px', fontSize:'14px' },
  input:     { width:'100%', padding:'14px', margin:'8px 0', borderRadius:'10px', border:'1px solid #ddd', fontSize:'16px', boxSizing:'border-box', textAlign:'right', direction:'rtl' },
  btn:       { width:'100%', padding:'14px', background:'linear-gradient(135deg,#10b981,#059669)', color:'#fff', border:'none', borderRadius:'10px', fontSize:'16px', fontWeight:'bold', cursor:'pointer', marginTop:'10px' },
  error:     { color:'#e74c3c', fontSize:'14px', margin:'5px 0' },
  switchText:{ marginTop:'20px', color:'#888', fontSize:'14px' },
  link:      { color:'#10b981', cursor:'pointer', fontWeight:'bold' },
};
